import { Pipe, PipeTransform } from "@angular/core";
import { Message } from "@handshake/core-types";

@Pipe({
  name: "isDiffDate",
})
export class IsDiffDatePipe implements PipeTransform {
  transform(message: Message, messages: Message[], index: number): boolean {
    return this.isNewDate(message, messages, index);
  }

  isNewDate(currentMessage: Message, messages: Message[], index: number): boolean {
    if (index === 0) return true;

    const previousMessage = messages[index - 1];
    const currentDate = new Date(currentMessage.createdAt).setHours(0, 0, 0, 0);
    const previousDate = new Date(previousMessage.createdAt).setHours(0, 0, 0, 0);

    return currentDate !== previousDate;
  }
}
